<template>
  <FullScreenDialog
    v-model="dialog"
    without-padding
    title="Colori Di Capelli"
    :route-father="routeFather"
  >
    <template v-slot:header-actions>
      <v-btn text link @click="goToNew">
        <v-icon class="mr-2">mdi-plus</v-icon> Nuovo
      </v-btn>
    </template>
    <template v-slot:toolbar-extension>
      <div class="d-flex justify-center align-center" style="width: 100%">
        <AdvancedSearch
          class="ml-2 mb-2"
          placeholder="Cerca Colore di Capelli ..."
          @apply="applyFilters"
          :show-filter-buttons="false"
        ></AdvancedSearch>
      </div>
    </template>
    <template v-slot:content>
      <div style="height: 100%; overflow-y: hidden" ref="dataTableWrapper">
        <TypeDataTable
          v-model="selected"
          loading-text="Caricamento hairColors ..."
          :headers="headers"
          :loading="loading"
          :items="filteredHairColors"
          :page.sync="page"
          :row-per-page.sync="rowPerPage"
          :total-pages.sync="totalPages"
          :height="dataTableHeight"
          :show-select="false"
          @edit="handleEdit"
          @delete="handleDelete"
          @dblclick:row="handleEditDoubleClick"
        ></TypeDataTable>
      </div>
    </template>
  </FullScreenDialog >
</template>

<script>
import FullScreenDialog from '@/components/common/FullScreenDialog.vue'
import StandardMenu from '@/components/common/StandardMenu.vue'
import TypeDataTable from '@/components/common/TypeDataTable.vue'
import AdvancedSearch from "@/components/common/AdvancedSearch.vue";
import hairColorsService from '@/services/hairColors/hairColors.service.js'

export default {
  name: "HairColorsRegistryList",
  components: {
    FullScreenDialog,
    TypeDataTable,
    StandardMenu,
    AdvancedSearch
  },
  data: function() {
    let props = this.$router.resolve({name: 'Registries'});

    return {
      dialog: true,
      loadingItems: false,
      loadingHeaders: false,
      routeFather: props.href,
      selected: undefined,
      dataTableHeightValue: 400,
      hairColors: [],
      headers: [],
      page: 1,
      rowPerPage: 100,
      totalPages: 0,
      resizeListener: undefined
    }
  },
  mounted: function() {
    this.fetchHeaders()
    this.fetchHairColors()

    this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60

    this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60
    this.resizeListener = function() {
      this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60
    }
    this.resizeListener = this.resizeListener.bind(this)
    window.addEventListener('resize', this.resizeListener)
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.resizeListener)
  },
  methods: {
    fetchHairColors(filters) {
      this.loadingItems = true
      hairColorsService.list(this.page, this.rowPerPage, filters).then((results) => {
        if(this.rowPerPage != results.rowPerPage) {
          this.rowPerPage = results.rowPerPage
        }

        if(this.page != results.page) {
          this.page = results.page
        }

        this.totalPages = results.totalPages
        if(!!this.totalPages && this.totalPages < this.page) {
          this.page = this.totalPages
        }

        this.hairColors = results.rows
        this.loadingItems = false
      })
    },
    fetchHeaders() {
      this.loadingHeaders = true
      hairColorsService.fields().then((headers) => {
        this.headers = headers
        this.loadingHeaders = false
      })
    },
    handleEdit(hairColor) {
      this.$router.push({
        name: 'HairColorsRegistryEditForm',
        params: {
          id: hairColor.id
        },
        query: {
          pathToGoBack: this.$router.resolve({name: 'HairColorsRegistryList'}).href
        }
      })
    },
    handleEditDoubleClick(row, {item: hairColor}) {
      this.$router.push({
        name: 'HairColorsRegistryEditForm',
        params: {
          id: hairColor.id
        },
        query: {
          pathToGoBack: this.$router.resolve({name: 'HairColorsRegistryList'}).href
        }
      })
    },
    handleDelete(hairColor) {
      let confirmed = confirm('Sei sicuro di voler eliminare ' + hairColor.name + ' ?')

      if(confirmed) {
        this.loadingItems = true
        hairColorsService.archive(hairColor).then(() => {
          this.fetchHairColors()
          this.loadingItems = false
        })
      }
    },
    goToNew() {
      this.$router.push({
        name: 'HairColorsRegistryNewForm',
        query: {
          pathToGoBack: this.$router.resolve({name: 'HairColorsRegistryList'}).href
        }
      })
    },
    applyFilters(filters) {
      this.fetchHairColors(filters);
    },
  },
  computed: {
    filteredHairColors() {
      return this.hairColors
    },
    loading() {
      return this.loadingItems || this.loadingHeaders
    },
    dataTableHeight() {
      return this.dataTableHeightValue + 'px'
    }
  },
  watch: {
    page() {
      this.fetchHairColors()
    },
    rowPerPage() {
      this.fetchHairColors()
    },
  }
}
</script>